/**
 * Masks everything but the last 4 digits of the tax id on the
 * application after it is submitted.
 *
 * @param {string} value the field value
 * @param {boolean} disabled the disabled state of the input. defaults to false
 */
export default function maskTaxId(value, disabled = false) {
  if (!disabled || !value) return value;
  return value.replace(/.(?=.{4})/g, 'X');
}
